import React from 'react'

import styles from './styles.module.css'

export default function({ children }){
    return (
        <h2 className={styles.subtitle + " m-4"}>{ children }</h2>
    )
}